import numeral from 'numeral'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { numeralSetupIt } from '../../../utils/numeralSetupIt'
import CouponConfig from '../../common/CouponConfig'
import {
  filesBaseUrl,
  haGaranzia3Anni,
  isFindomestic,
  productImagePlaceholder,
} from '../utils'
import BuyPricePromozione from './BuyPricePromozione'

const BuyMiniCart = ({
  idAuto,
  km,
  year,
  price,
  ownership,
  product,
  agevolazione_iva_104,
  totalone,
  prezzoLogisticaPromozione,
  prezzoLogistica,
  isFreePrice,
  centroConvenzionatoNome,
  numberOrText,
  finanziamento,
  paymentMethod,
  sconto,
  acconti,
  garanzia,
  serviziAssicurativiSelezionati,
  onlyFinanziamento,
  finanziamentoNonAssicurato,
  ordine,
  ui,
}) => {
  const [productImage, setProducImage] = React.useState(
    `${filesBaseUrl}/pictures/${idAuto}/close.27.mid.jpg`
  )
  const totalePremiAssicurativi = Object.values(
    finanziamento && finanziamento.premi_assicurativi
      ? finanziamento.premi_assicurativi
      : {}
  ).reduce((el, acc) => el + acc, 0)

  const handleImageError = () => {
    setProducImage(productImagePlaceholder)
  }

  return (
    <div className="the-minicart static" id="minicart_rows">
      {!onlyFinanziamento ? (
        <div className="f-table minicart">
          <div className="row wide">
            <div className="carbox">
              <div className="carbox__item">
                <div className="carbox__image">
                  <img onError={handleImageError} src={productImage} />
                </div>
                <div className="carbox__info">
                  <div className="carbox__title minicart-title">
                    <h4>
                      <span className="brand">{product.marca}</span>

                      {product.modello === product.marca ? (
                        <span className="brand">
                          {' '}
                          {product.allestimento_breve}
                        </span>
                      ) : (
                        <span className="brand"> {product.modello}</span>
                      )}
                    </h4>

                    <span className="minicart-det">
                      {product.allestimento_breve}
                    </span>
                    <span className="minicart-det">
                      {product.motorizzazione}
                    </span>

                    <br />

                    <span className="minicart-det">{product.cambio}</span>
                    <span className="minicart-det">
                      {product.km0 === 'Si' ? (
                        <span className="km-0">km 0</span>
                      ) : (
                        `${numeral(km).format('0,0')} km`
                      )}
                    </span>
                    <span className="minicart-det">{year}</span>
                  </div>
                  <div
                    className="carbox__price minicart-price"
                    style={sconto ? { fontSize: '14px' } : {}}
                  >
                    {sconto ? (
                      <div>
                        <BuyPricePromozione
                          isFreePrice
                          numberOrText={'number'}
                          prezzoLogistica={numeral(price).format('$ 0,0[.]00')}
                          prezzoLogisticaPromozione={numeral(
                            price - sconto
                          ).format('$ 0,0[.]00')}
                          promoLabel={'Sconto'}
                        />
                        {agevolazione_iva_104 ? (
                          <span style={{ fontSize: '0.85rem' }}>(IVA 4%)</span>
                        ) : null}
                      </div>
                    ) : (
                      <div>
                        <h4>
                          <span>{numeral(price).format('$ 0,0[.]00')}</span>
                        </h4>
                        {agevolazione_iva_104 ? (
                          <span style={{ fontSize: '0.85rem' }}>(IVA 4%)</span>
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="left">Passaggio di proprietà</div>
            <div className="right">
              {numeral(ownership).format('$ 0,0[.]00')}
            </div>
          </div>

          <div className="row">
            <div className="left">
              Consegna presso
              <br />
              <span className="citta-scelta">{centroConvenzionatoNome}</span>
            </div>
            <div className="right">
              <BuyPricePromozione
                isFreePrice={isFreePrice}
                numberOrText={numberOrText}
                prezzoLogistica={prezzoLogistica}
                prezzoLogisticaPromozione={prezzoLogisticaPromozione}
              />
            </div>
          </div>

          <div className="row">
            <div className="left">Lavaggio ed igienizzazione professionale</div>
            <div className="right">
              <span className="blue">Incluso</span>
            </div>
          </div>
          {ordine.servizi_extra && ordine.servizi_extra.ordini_servizi
            ? ordine.servizi_extra.ordini_servizi.map(servizio_aggiuntivo => (
                <div
                  className="row"
                  key={`vas-${servizio_aggiuntivo.id_servizio}`}
                >
                  <div className="left">
                    {servizio_aggiuntivo.titolo || 'no title'}
                  </div>
                  <div className="right">
                    <BuyPricePromozione
                      isFreePrice
                      numberOrText={'number'}
                      prezzoLogistica={
                        servizio_aggiuntivo.prezzo_listino
                          ? numeral(servizio_aggiuntivo.prezzo_listino).format(
                              '$ 0,0[.]00'
                            )
                          : numeral(servizio_aggiuntivo.prezzo).format(
                              '$ 0,0[.]00'
                            )
                      }
                      prezzoLogisticaPromozione={numeral(
                        servizio_aggiuntivo.prezzo
                      ).format('$ 0,0[.]00')}
                    />
                  </div>
                </div>
              ))
            : null}

          {ordine.codice_preventivo ? (
            <div className="row">
              <div className="left">
                {ordine.minicart_label || 'Coupon / Cod.Preventivo'}
              </div>
              <div className="right text-break">
                <span className="main">{ordine.codice_preventivo}</span>
              </div>
              <CouponConfig
                couponCode={ordine.codice_preventivo}
                selloutSettings={ui.sellout_settings_acquista}
              />
            </div>
          ) : null}

          {haGaranzia3Anni(garanzia) && (
            <div className="row">
              <div className="left">
                3 anni di garanzia sui guasti e assistenza stradale
              </div>
              <div className="right">
                <span className={'yellow'}>Inclusa</span>
              </div>
            </div>
          )}

          {acconti ? (
            <div
              className="row last foot gray calculate-total"
              style={{
                paddingTop: '10px',
              }}
            >
              <div
                className="left"
                style={{
                  fontWeight: 100,
                  width: '50%',
                  padding: '0',
                }}
              >
                Totale ordine
              </div>
              <div
                className="right"
                style={{
                  width: '50%',
                  padding: 0,
                }}
              >
                <span id="total" style={{ fontWeight: 100 }}>
                  {numeral(totalone).format('$ 0,0[.]00')}
                </span>
              </div>
            </div>
          ) : null}
          {acconti ? (
            <div className="row last foot gray calculate-total">
              <div
                className="left"
                style={{ fontWeight: 100, width: '60%', padding: 0 }}
              >
                Acconto pre-autorizzato
              </div>
              <div className="right" style={{ width: '40%', padding: 0 }}>
                <span id="total" style={{ fontWeight: 100 }}>
                  {numeral(acconti).format('$ 0,0[.]00')}
                </span>
              </div>
            </div>
          ) : null}
          <div className="row last foot gray calculate-total">
            <div className="left">Totale {acconti ? 'dovuto' : null}</div>
            <div className="right">
              <span id="total">
                {numeral(totalone - acconti).format('$ 0,0[.]00')}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="f-table minicart minicart--only-image">
          <div className="row wide">
            <div className="carbox">
              <div className="carbox__item">
                <div className="carbox__image">
                  <img
                    src={
                      idAuto !== null
                        ? `${window.brumbrum.files_domain}/pictures/${idAuto}/close.27.mid.jpg`
                        : ''
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {paymentMethod === 'finanziamento' ||
      paymentMethod === 'finanziamento_findomestic' ? (
        <div className="f-table minicart minicart--financing">
          <div
            className={
              isFindomestic(product)
                ? 'minicartFinanziamentoFindomestic'
                : 'minicartFinanziamentoCompass'
            }
            id="minicartFinanziamento"
          >
            <strong>La tua richiesta di finanziamento</strong>
            {isFindomestic(product) ? (
              <img
                className="logo-findomestic"
                src={`${filesBaseUrl}/asset_sito/logo-findomestic.png`}
              />
            ) : null}

            {paymentMethod === 'finanziamento' ? (
              <img
                className="logo-compass"
                src={`${filesBaseUrl}/asset_sito/logo-compass.png`}
              />
            ) : null}

            <div className="row">
              <div className="left">
                {serviziAssicurativiSelezionati.length
                  ? 'Importo rata totale'
                  : 'Importo rata mensile'}
              </div>
              <div className="right">
                {numeral(finanziamento.importo_rata).format('$ 0,0[.]00')}
              </div>

              {serviziAssicurativiSelezionati.length &&
              finanziamentoNonAssicurato &&
              finanziamentoNonAssicurato.id_finanziamento ? (
                <div className="row__financing-details">
                  <div className="left">di cui: rata senza assicurazioni</div>
                  <div className="right">
                    {numeral(finanziamentoNonAssicurato.importo_rata).format(
                      '$ 0,0[.]00'
                    )}
                  </div>
                </div>
              ) : null}

              {serviziAssicurativiSelezionati.length &&
              finanziamentoNonAssicurato &&
              finanziamentoNonAssicurato.id_finanziamento ? (
                <div className="row__financing-details">
                  <div className="left">
                    di cui: rata relativa assicurazioni
                  </div>
                  <div className="right">
                    {numeral(
                      finanziamento.importo_rata -
                        finanziamentoNonAssicurato.importo_rata
                    ).format('$ 0,0[.]00')}
                  </div>
                </div>
              ) : null}
            </div>

            <div className="row">
              <div className="left">Numero rate</div>
              <div className="right">{finanziamento.numero_rate}</div>
            </div>

            <div className="row">
              <div className="left">Importo totale finanziato</div>
              <div className="right">
                {numeral(finanziamento.importo_finanziato).format('$ 0,0[.]00')}
              </div>

              {serviziAssicurativiSelezionati.length &&
              finanziamento.premi_assicurativi &&
              Object.keys(finanziamento.premi_assicurativi).length ? (
                <div className="row__financing-details">
                  <div className="left">
                    di cui: importo finanziato senza premio assicurativo
                  </div>
                  <div className="right">
                    {numeral(
                      finanziamento.importo_finanziato - totalePremiAssicurativi
                    ).format('$ 0,0[.]00')}
                  </div>
                </div>
              ) : null}
              {serviziAssicurativiSelezionati.length &&
              finanziamento.premi_assicurativi &&
              Object.keys(finanziamento.premi_assicurativi).length ? (
                <div className="row__financing-details">
                  <div className="left">di cui: premio assicurativo totale</div>
                  <div className="right">
                    {numeral(totalePremiAssicurativi).format('$ 0,0[.]00')}
                  </div>
                </div>
              ) : null}
            </div>

            <div className="row">
              <div className="left">Acconto totale</div>
              <div className="right">
                {numeral(finanziamento.anticipo).format('$ 0,0[.]00')}
              </div>
            </div>

            {isFindomestic(product) ? (
              <div className="row">
                <div className="left full-row brumbrum-link">
                  <a
                    href={finanziamento.iebccUrl}
                    rel="noreferrer"
                    target="_blank"
                  >
                    Scarica il modulo informativo (IEBCC)
                  </a>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  )
}

BuyMiniCart.defaultProps = {
  numeral: numeralSetupIt(),
  finanziamento: {},
  agevolazione_iva_104: false,
  onlyFinanziamento: false,
  serviziAssicurativiSelezionati: [],
  finanziamentoNonAssicurato: {},
}

BuyMiniCart.propTypes = {
  idAuto: PropTypes.string,
  km: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ownership: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  product: PropTypes.object,
  agevolazione_iva_104: PropTypes.bool,
  totale: PropTypes.number,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalone: PropTypes.number,
  acconti: PropTypes.number,
  prezzoLogisticaPromozione: PropTypes.string,
  finanziamento: PropTypes.object,
  prezzoLogistica: PropTypes.string,
  numberOrText: PropTypes.string,
  isFreePrice: PropTypes.bool,
  centroConvenzionatoNome: PropTypes.string,
  paymentMethod: PropTypes.string,
  onlyFinanziamento: PropTypes.bool,
  serviziAssicurativiSelezionati: PropTypes.array,
  finanziamentoNonAssicurato: PropTypes.object,
}

const mapStateToProps = state => ({
  garanzia: state.garanzia,
  ui: state.ui,
})

export default connect(mapStateToProps, null)(BuyMiniCart)
